<cdk-virtual-scroll-viewport
  itemSize="72"
  class="chat-list fixed-height"
  linScrollable
  (scrollPosition)="scrollHandler()"
  [ngClass]="{ 'with-loader': isLoading$ | async }"
>
  <ng-container *ngIf="chatList.length; else noChats">
    <ng-container *cdkVirtualFor="let chat of chatList; trackBy: trackById">
      <lin-chat [chat]="chat" [isToolbar]="isToolbar"></lin-chat>
    </ng-container>
  </ng-container>

  <div *ngIf="isLoading$ | async;" class="chat-list-loader">
    <mat-spinner strokeWidth="2" diameter="30" color="accent"></mat-spinner>
  </div>
</cdk-virtual-scroll-viewport>
<ng-template #noChats>
  <div class="chat-list empty fixed-height" *ngIf="(isLoading$ | async) === false" [ngClass]="{ 'with-loader': isLoading$ | async }">
    {{ 'CLIENT.MESSENGER.CHAT_LIST.NO_CHATS' | translate }}
  </div>
</ng-template>
